import React from 'react';
import { Accordion, AccordionSummary, Stack, Typography, AccordionDetails } from '@mui/material';
import { EuroOutlined, ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import TuoteHintarivit from '@/components/Hintarivit/TuoteHintarivit';

const HintarivitAccordion = ({ tuote }) => {
  const { t } = useTranslation();

  return (
    <Accordion
      sx={{
        'boxShadow': 'none',
        'marginTop': 0,
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="address-content"
        id="address-header"
        sx={{
          'padding': 0,
          'minHeight': 0,
          'borderBottom': 'none',
          '&.Mui-expanded': {
            minHeight: 0,
            borderBottom: 'none',
          },
          '& .MuiAccordionSummary-content': {
            margin: 0,
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
          <EuroOutlined />
          <Typography sx={{ flex: 1 }}>
            {t('hintarivitAccordion.priceRows')}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>
        <TuoteHintarivit tuote={tuote} />
      </AccordionDetails>
    </Accordion>
  );
};

export default HintarivitAccordion;
